<!--
/**
* @description: 审核详情
* @author: 张伟
* @time: 2022-04-07 14:25:56
*/
-->
<template>
  <y-view :loading="isLoading">
    <div :class="css.title">
      <div>{{ detail.accountName }}</div>
      <div :class="css.status">{{ detail.statusName }}</div>
    </div>
    <div>
      <y-form title="法人信息" titleWidth="100px" titleAlign="right">
        <div class="row" style="flex-wrap: wrap">
          <y-form-item title="法人名称：">{{ detail.bankAccountSnapshot.legalPersonName || '' }}</y-form-item>
          <y-form-item title="身份证号：">{{ detail.bankAccountSnapshot.legalPersonID || '' }}</y-form-item>
        </div>
      </y-form>
      <y-form title="提现账户信息" titleWidth="100px" titleAlign="right">
        <div class="row" style="flex-wrap: wrap">
          <y-form-item title="账户名称：">{{ detail.bankAccountSnapshot.accountName || '' }}</y-form-item>
          <y-form-item title="身份证号：">{{ detail.bankAccountSnapshot.nricNo || '' }}</y-form-item>
          <y-form-item title="银行预留手机号：">{{ detail.bankAccountSnapshot.mobile || '' }}</y-form-item>
          <y-form-item title="开户行：">{{ detail.bankAccountSnapshot.bankName || '' }}</y-form-item>
          <y-form-item title="银行账号：">{{ detail.bankAccountSnapshot.bankAccountNo || '' }}</y-form-item>
          <y-form-item title="委托收款函："><a href="javascript:void(0)" v-if="detail.authorizedLetter" @click="showImg">查看</a></y-form-item>
        </div>
      </y-form>
    </div>
    <div slot="bottom">
      <k-button @click="isShowRefuse=true">驳回</k-button>
      <k-button type="primary" @click="audit">审核通过</k-button>
    </div>
    <y-anchor :anchor="anchorList"></y-anchor>
    <k-popup bind="v-if" title="驳回" :show.sync="isShowRefuse" @after-ok="onSaveRefuse">
      <y-popup-body size="small">
        <y-form>
          <y-form-item title="备注" required>
            <k-input tag="textarea" v-model="reason" placeholder="请输入拒绝原因" :style="{width:'100%'}" rows="10"></k-input>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_DETAIL, NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_OPERATOR
} from "@/assets/modules/apiList";

export default {
  name: "auditDetail",
  data() {
    return {
      isLoading: false,
      isShowRefuse: false,
      reason: '',
      detail: {
        bankAccountSnapshot: {}
      }
    }
  },
  created() {
    const { id } = this.$route.query;
    this.getDetail(id);
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    this.getDetail(id);
    next();
  },
  methods: {
    getDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_DETAIL,
        para: { id }
      }).then(res => {
        this.isLoading = false;
        this.detail = res;
      });
    },
    //图片预览
    showImg() {
      this.$viewerApi({
        images: [ this.detail.authorizedLetter ]
      })
    },
    //驳回
    onSaveRefuse() {
      if (!this.reason) {
        return this.$root.tip('请输入拒绝原因');
      }
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_OPERATOR,
        para: { id: this.detail.id, action: 'reject', message: this.reason }
      }).then(res => {
        this.$root.tip('操作成功', 'success');
        this.isShowRefuse = false;
        setTimeout(() => {
          this.closePage(true, true);
        }, 500)
      });
    },
    //审核通过
    audit() {
      this.$dialog({
        title: '温馨提示',
        content: '确认审核通过吗',
        ok: () => {
          this.$fetch({
            api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_BANK_AUDIT_OPERATOR,
            para: { id: this.detail.id, action: 'agree' }
          }).then(res => {
            this.$root.tip('操作成功', 'success');
            setTimeout(() => {
              this.closePage(true, true);
            }, 500)
          });
        }
      })
    },
    //关闭当前页
    closePage(isRefresh, isClose) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "accountAuditList",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    }
  }
}
</script>

<style lang="postcss" module="css">
.title {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: var(--color-font-1);
  font-weight: bold;
  margin-bottom: 25px;
}

.status {
  padding: 0 5px;
  border-radius: 3px;
  font-size: 12px;
  margin-left: 10px;
  color: #f55555;
  background-color: rgba(245, 108, 108, 0.4);
}
</style>
